<template>
    <v-container fluid>
        <v-card class="ma-2" outlined rounded>
            <v-card-title>
                <v-btn icon @click="$router.go(-1)">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-icon class="mr-1" color="green">mdi-account-group</v-icon>
                {{ formTitle }}
            </v-card-title>
            <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
    
            <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">
                <v-row>
                    <v-col lg="6" md="6" sm="12">
                        <v-text-field v-model="editedItem.name" :rules="requiredRule" label="Group Name*" required></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="6" md="6" sm="12">
                        <v-autocomplete v-model="select" :rules="requiredRule" :loading="loading" :items="userList" :search-input.sync="search" no-filter clearable return-object label="Owner*" placeholder="ค้นหาชื่อ" required />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="6" md="6" sm="12">
                        <v-textarea v-model="editedItem.desc" label="Description" rows="3" auto-grow></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="3" md="3" sm="6">
                        <v-text-field v-model="editedItem.linegroup" label="Line Group"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="3" md="3" sm="6">
                        <v-text-field v-model="editedItem.password" :rules="requiredRule" label="Password*" required maxlength="6"></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
    
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="goToDashboard">
                    Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save" :loading="loading">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    
        <v-snackbar v-model="snackbar" multi-line>
            {{ text }}
    
            <template v-slot:actions>
                    <v-btn
                      color="red"
                      variant="text"
                      @click="snackbar = false"
                    >
                      Close
                    </v-btn>
</template>
    </v-snackbar>
  </v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import {
    mapGetters
} from "vuex";
import getGroupInfoById from '../data/getGroupInfoById';
import getUserList from '../data/getUserList';
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import getGroupList from '../data/getGroupList';
import setGroupData from '../data/setGroupData';

export default {
    name: 'GroupForm',
    metaInfo: {
        title: 'Group Form',
    },
    data() {
        return {
            editedItem: {
                name: "",
                desc: "",
                owner: "",
                linegroup: "",
                password: ""
            },
            defaultItem: {
                name: "",
                desc: "",
                owner: "",
                linegroup: "",
                password: ""
            },
            valid: false,
            loading: false,
            requiredRule: [
                v => !!v || "Required."
            ],
            snackbar: false,
            text: "",
            isEdit: false,
            select: null,
            userList: [],
            search: null
        };
    },
    watch: {
        select(value) {
            this.$emit("input", value ? value.value : null);
        },
        search(query) {
            if (query && (!this.select || this.select.text !== query)) {
                this.querySearch(query);
            } else {
                if (this.select != null) {
                    this.preload(this.select.value);
                } else {
                    this.userList = [];
                }
            }
        },
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        // Check if this is edit mode
        this.id = this.$route.params.id;
        if (this.id) {
            this.isEdit = true;
        }
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
        formTitle() {
            return this.isEdit ? "Edit Group" : "Add New Group";
        }
    },
    methods: {
        initialize() {
            if (this.isEdit) {
                this.loadGroupData();
            } else {
                //get random password for 6 digits
                this.editedItem.password = Math.floor(100000 + Math.random() * 900000);
                this.loading = false;
            }
        },
        preload(uid) {
            (async () => {
                if (uid) {
                    this.loading = true;
                    const userInfo = await getUserInfoByUserId(uid);
                    if (this.$route.name != 'Admin Add') {
                        this.title = 'Edit';
                    }
                    let displayText = userInfo.phoneNumber ? userInfo.phoneNumber : userInfo.email;
                    if (displayText.startsWith('line-')) {
                        displayText = 'Line';
                    }
                    this.select = {
                        value: uid,
                        text: userInfo.name + " (" + displayText + ")"
                    };
                    this.userList = [this.select];
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            })();
        },
        async loadGroupData() {
            try {
                const groupData = await getGroupInfoById(this.id);
                if (groupData) {
                    this.preload(groupData.owner);
                    this.editedItem = {
                        name: groupData.name || "",
                        desc: groupData.desc || "",
                        owner: groupData.owner || "",
                        linegroup: groupData.linegroup || "",
                        password: groupData.password || ""
                    };
                }
                this.loading = false;
            } catch (error) {
                console.error("Error loading group data:", error);
                this.showSnackbar("Error loading group data");
                this.loading = false;
            }
        },

        async save() {
            // Validate form
            await this.$refs.form.validate();

            if (this.valid) {
                this.loading = true;

                try {
                    const groupData = {
                        name: this.editedItem.name,
                        desc: this.editedItem.desc,
                        owner: this.select.value,
                        linegroup: this.editedItem.linegroup,
                        password: this.editedItem.password,
                        updatedAt: new Date(),
                        updatedBy: this.loggedInUserId
                    };

                    if (this.isEdit) {
                        // Update existing group
                        await setGroupData(groupData, this.id);
                        this.showSnackbar("Group updated successfully!");
                        // Redirect to the new group view
                        setTimeout(() => {
                            this.$router.push(`/group/view/${this.id}`);
                        }, 1500);
                        return;
                    } else {
                        //get group id from firestore lastest and plus 1
                        const groupList = await getGroupList();
                        const lastGroup = groupList[groupList.length - 1];
                        const lastGroupId = parseInt(lastGroup.value) * 1;
                        const newGroupId = lastGroupId + 1;
                        // Create new group
                        groupData.createdAt = new Date();
                        groupData.createdBy = this.loggedInUserId;
                        groupData.groupId = newGroupId;
                        groupData.password = this.editedItem.password + '';
                        const docRef = await setGroupData(groupData, newGroupId);
                        this.showSnackbar("Group created successfully!");
                        // Redirect to the new group view
                        setTimeout(() => {
                            this.$router.push(`/group/view/${docRef.id}`);
                        }, 1500);
                        return;
                    }

                } catch (error) {
                    console.error("Error saving group:", error);
                    this.showSnackbar("Error saving group");
                    this.loading = false;
                }
            }
        },

        showSnackbar(message) {
            this.text = message;
            this.snackbar = true;
        },

        goToDashboard() {
            this.$router.push(`/dashboard`);
        },
        querySearch(query) {
            (async () => {
                if (query) {
                    const userListResult = await getUserList("filter", query, []);
                    const userArray = [];
                    userListResult.forEach((user) => {
                        let displayText = user.phoneNumber ? user.phoneNumber : user.email;
                        if (displayText.startsWith('line-')) {
                            displayText = 'Line';
                        }
                        userArray.push({
                            value: user.uid,
                            text: user.name + " (" + displayText + ")"
                        });
                    });
                    this.userList = userArray;
                }
            })();
        },
    }
};
</script>